import React from "react";
import { evaluateProp } from "../victory-util/helpers";
export const TSpan = props => {
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars --
   * origin conflicts with the SVG element's origin attribute
   */
  const {
    desc,
    id,
    tabIndex,
    origin,
    ...rest
  } = props;
  const svgProps = {
    id: evaluateProp(id, props)?.toString(),
    tabIndex: evaluateProp(tabIndex, props),
    ...rest
  };
  return /*#__PURE__*/React.createElement("tspan", svgProps);
};